import React, { FC } from 'react'

type IconProps = {
  className?: string
  direction?: 'up' | 'down' | 'left' | 'right'
}

export const ChevronArrowIcon: FC<IconProps> = ({ className, direction = 'right' }) => {
  return (
    <svg
      className={className}
      fill={'currentColor'}
      height={'20'}
      style={{
        transform:
          direction === 'up'
            ? 'rotate(180deg)'
            : direction === 'down'
            ? 'rotate(0deg)'
            : direction === 'left'
            ? 'rotate(90deg)'
            : direction === 'right'
            ? 'rotate(270deg)'
            : 'none',
      }}
      viewBox={'0 0 20 20'}
      width={'20'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <g id={'chevron-group'}>
        <path
          d={
            'M9.48047 14.0195L3.48047 8.01953C3.16797 7.73828 3.16797 7.26953 3.48047 6.95703C3.76172 6.67578 4.23047 6.67578 4.54297 6.95703L10.0117 12.457L15.4805 6.98828C15.7617 6.67578 16.2305 6.67578 16.543 6.98828C16.8242 7.26953 16.8242 7.73828 16.543 8.01953L10.5117 14.0195C10.2305 14.332 9.76172 14.332 9.48047 14.0195Z'
          }
          id={'icon path'}
        />
      </g>
    </svg>
  )
}
